var map = {
	"./53d47c8b9a9eb6edd0e2f65a19a3d7d00846d8101f7a5-W5fFMs.png": 1485,
	"./Group 21864.png": 1486,
	"./content-deco-1.webp": 1487,
	"./content-deco-2.webp": 1488,
	"./content-deco-3.webp": 1489,
	"./home-icon-active.webp": 1490,
	"./home-icon.webp": 1491,
	"./live-chat-active.webp": 1492,
	"./live-icon.webp": 1493,
	"./me-icon-active.webp": 1494,
	"./me-icon.webp": 1495,
	"./product-overview-bg.webp": 1496,
	"./promos-icon-active.webp": 1497,
	"./promos-icon.webp": 1498,
	"./services-bg.webp": 1499,
	"./sponsor-icon-active.webp": 1500,
	"./sponsor-icon.webp": 1501,
	"./vip-icon-active.webp": 1502,
	"./vip-icon.webp": 1503,
	"./wwr-img.webp": 1504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;